module.exports = __webpack_public_path__ + "static/02-5333f189f806fc9cfba8094b42fbe026.jpg";